import { Component, Input } from '@angular/core';

@Component({
  selector: 'kp-screen-email-signup-base',
  templateUrl: './screen-email-signup-base.component.html',
  styleUrls: ['./screen-email-signup-base.component.scss'],
})
export class ScreenEmailSignupBaseComponent {
  @Input() headerTitle: string;
}
